export default __webpack_public_path__ + "static/book2222-78c4cb3278ca673814e3dbe8ec9ad360.png";